import { render, staticRenderFns } from "./groupDialog.vue?vue&type=template&id=0b8a9206&"
import script from "./groupDialog.vue?vue&type=script&lang=js&"
export * from "./groupDialog.vue?vue&type=script&lang=js&"
import style0 from "./groupDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports